import axios from 'axios';
import appConfig from '@/config';
import { getCookie } from '@/utils/auth/authService';
const BASE_URL = appConfig.api.base;

//get all banks.
export function getAllBanks() {
  const url = `${BASE_URL}/utils/banks`;
  let token = getCookie('token');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
    },
  })
}

export function getAllCurrencies() {
  const url = `${BASE_URL}/utils/currencies`;
  let token = getCookie('token');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
    },
  })
}

export function getBankBranch(bankcode, country) {
  const url = `${BASE_URL}/utils/banks/branch?bankcode=${bankcode}&country=${country}`;
  let token = getCookie('token');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
    },
  })
}

//resolve account name
export function resolveAccountName(accountObj) {
  const url = `${BASE_URL}/beneficiaries/resolve`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');

  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id': merchantId
    },
    data:{
      account_number: accountObj.accountNumber,
      bank_code: accountObj.accountBankCode,
      currency: accountObj.currency,
    }
  })
}

export function validateBvnOtp(otp, ref) {
  const url = `${BASE_URL}/user/verify/bvn/validate`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');

  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id': merchantId
    },
    data:{
      otp,
      ref
    }
  })
}

export function foundBvn(bvn, email) {
  const url = `${BASE_URL}/user/verify/bvn`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');

  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id': merchantId
    },
    data:{
      email: email,
      useNew: true,
      bvn
    }
  })
}

//validate phone number
export function phoneNumberValid(value){
  return (value.match(/^[0-9]+$/) != null && value.match(/\d/g).length >= 6)
}

//return value to lower case
export function toLowerCase(value){
  return value.toLowerCase()
}

export async function validateImageMagicNumber(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const uint8Array = new Uint8Array(event.target.result);

            // JPEG: 0xFF 0xD8 0xFF
            if (
                uint8Array[0] === 0xff &&
                uint8Array[1] === 0xd8 &&
                uint8Array[2] === 0xff
            ) {
                resolve(true); // JPEG
                return;
            }

            // JPG: 0xFF 0xD8 0xFF
            if (
                uint8Array[0] === 0xff &&
                uint8Array[1] === 0xd8 &&
                uint8Array[2] === 0xff
            ) {
                resolve(true); // JPG
                return;
            }

            // PNG: 0x89 0x50 0x4E 0x47 0x0D 0x0A 0x1A 0x0A
            if (
                uint8Array[0] === 0x89 &&
                uint8Array[1] === 0x50 &&
                uint8Array[2] === 0x4e &&
                uint8Array[3] === 0x47 &&
                uint8Array[4] === 0x0d &&
                uint8Array[5] === 0x0a &&
                uint8Array[6] === 0x1a &&
                uint8Array[7] === 0x0a
            ) {
                resolve(true); // PNG
                return;
            }

            // PDF: 0x25 0x50 0x44 0x46
            if (
                uint8Array[0] === 0x25 &&
                uint8Array[1] === 0x50 &&
                uint8Array[2] === 0x44 &&
                uint8Array[3] === 0x46
            ) {
                resolve(true); // PDF
                return;
            }

            resolve(false); // Invalid magic number
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsArrayBuffer(file.slice(0, 8)); // Read the first 8 bytes
    });
}



// WEBPACK FOOTER //
// ./src/utils/helpers/utilitiesService.js